import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createRecurring } from "./RecurringService";
import { getAllAccounts } from "../expense/accounts/AccountService"
import { getAllCategories } from "../expense/categories/CategoryService"
import { getAllMerchants } from "../expense/merchants/MerchantService"
import "./RecurringForm.css";


export default function RecurringForm(){
const nav = useNavigate();


const [type,setType] = useState("SIP");
const [title,setTitle] = useState("");
const [description,setDescription] = useState("");
const [amount,setAmount] = useState("");
const [frequency,setFrequency] = useState("MONTHLY");
const [startDate,setStartDate] = useState("");
const [endDate,setEndDate] = useState("");
const [accountId,setAccountId] = useState("");
const [categoryId,setCategoryId] = useState("");
const [merchantId,setMerchantId] = useState("");
const [autoExecute,setAutoExecute] = useState(false);
const [accounts,setAccounts]=useState([]);
const [categories,setCategories]=useState([]);
const [merchants,setMerchants]=useState([]);


useEffect(()=>{
    load();
  },[]);

const load = async ()=>{
    setAccounts(await getAllAccounts());
    setCategories(await getAllCategories());
    setMerchants(await getAllMerchants());
  };

const submit = async (e)=>{
e.preventDefault();


const payload = {
type,
title,
description,
amount: Number(amount),
frequency,
startDate,
endDate: endDate || null,
accountId,
categoryId,
merchantId,
autoExecute
};

await createRecurring(payload);
nav("/finance/recurring");
};


return (
<form className="recurring-form-wrap" onSubmit={submit}>
<h2>Add Recurring Payment</h2>


<select value={type} onChange={e=>setType(e.target.value)}>
<option value="SIP">SIP</option>
<option value="EMI">EMI</option>
<option value="SUBSCRIPTION">Subscription</option>
<option value="RENT">Rent</option>
<option value="INSURANCE">Insurance</option>
<option value="BILL">Bill</option>
</select>


<input placeholder="Title" value={title} onChange={e=>setTitle(e.target.value)} />
<textarea placeholder="Description" value={description} onChange={e=>setDescription(e.target.value)} />


<input type="number" placeholder="Amount" value={amount} onChange={e=>setAmount(e.target.value)} />


<select value={frequency} onChange={e=>setFrequency(e.target.value)}>
<option value="DAILY">Daily</option>
<option value="WEEKLY">Weekly</option>
<option value="MONTHLY">Monthly</option>
<option value="YEARLY">Yearly</option>
</select>


<label>Start Date</label>
<input type="date" value={startDate} onChange={e=>setStartDate(e.target.value)} />


<label>End Date (optional)</label>
<input type="date" value={endDate} onChange={e=>setEndDate(e.target.value)} />


{/* <input placeholder="Account ID" value={accountId} onChange={e=>setAccountId(e.target.value)} />
<input placeholder="Category ID" value={categoryId} onChange={e=>setCategoryId(e.target.value)} />
<input placeholder="Merchant ID" value={merchantId} onChange={e=>setMerchantId(e.target.value)} /> */}

<select value={accountId} onChange={e=>setAccountId(e.target.value)}>
  <option value="">Select Account</option>
  {accounts.map(a=>(
    <option key={a.id} value={a.id}>
      {a.accountName || a.name || a.bankName || "Account"}
    </option>
  ))}
</select>

    <select value={categoryId} onChange={e=>setCategoryId(e.target.value)}>
  <option value="">Select Category</option>
  {categories.map(c=>(
    <option key={c.id} value={c.id}>
      {c.categoryName}
    </option>
  ))}
</select>

    <select value={merchantId} onChange={e=>setMerchantId(e.target.value)}>
  <option value="">Select Merchant</option>
  {merchants.map(m=>(
    <option key={m.id} value={m.id}>
      {m.merchantName}
    </option>
  ))}
</select>


<label>
<input type="checkbox" checked={autoExecute} onChange={e=>setAutoExecute(e.target.checked)} />
Auto execute
</label>


<button type="submit">Save</button>
</form>
);
}
